import Box from '@mui/material/Box';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import type { Citation } from '../api/schemas';
import { CiteContext, markdownComponents } from './markdownParts';

type Props = { text: string; citations: Citation[]; isLive?: boolean; onPage?: ((page: number) => void) | undefined };

/** [n] markers become links the Markdown renderer hands to the citation component. */
const withCiteLinks = (text: string) => text.replace(/\[(\d+)\]/g, '[[$1]](#cite-$1)');

/** The answer's Markdown: bold, lists, tables and short headings, with citations linking to the cited page.
 * While streaming (isLive) there are no citations yet, so markers show unlinked and each new block fades in. */
export function AnswerText({ text, citations, isLive = false, onPage }: Props) {
  const byNumber = new Map(citations.map((c) => [c.n, c]));
  return (
    <CiteContext value={{ byNumber, isLive, onPage }}>
      <Box
        sx={{
          fontSize: '0.875rem',
          lineHeight: 1.65,
          // The first block, whatever its tag. :first-of-type would also strip the first list or table after a paragraph,
          // and Emotion warns on :first-child. && keeps it above the block's own margin, as :not(* + *) adds no specificity.
          '&& > :not(* + *)': { mt: 0 },
          '& > :last-child': { mb: 0 },
        }}
      >
        <Markdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
          {withCiteLinks(text)}
        </Markdown>
      </Box>
    </CiteContext>
  );
}
